import React, { useEffect } from 'react';
import RefundView from './RefundView';
import WithLoading from '../../../Hoc/WithLoading';
import { getOrderApi } from '../Detail/OrderDetail';

const Refund = ({ id }) => {
  useEffect(() => {}, [id]);
  return (
    <WithLoading component={RefundView} url={getOrderApi.replace(':id', id)} />
  );
};

export default React.memo(Refund);
